/**
 * SortableHeader — clickable table column header with sort direction indicator.
 */

import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react'

interface SortableHeaderProps {
  label: string
  sortKey: string
  currentSortBy: string
  currentSortOrder: 'asc' | 'desc'
  onSort: (sortBy: string, sortOrder: 'asc' | 'desc') => void
  align?: 'left' | 'right'
  className?: string
}

export function SortableHeader({
  label, sortKey, currentSortBy, currentSortOrder, onSort, align = 'left', className = '',
}: SortableHeaderProps) {
  const isActive = currentSortBy === sortKey

  const handleClick = () => {
    if (isActive) {
      // Toggle direction
      onSort(sortKey, currentSortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      // New column, default to desc (most useful first)
      onSort(sortKey, 'desc')
    }
  }

  return (
    <th
      onClick={handleClick}
      className={`px-4 py-3 font-medium cursor-pointer select-none hover:text-foreground transition-colors group ${
        align === 'right' ? 'text-right' : ''
      } ${isActive ? 'text-foreground' : ''} ${className}`}
    >
      <span className={`inline-flex items-center gap-1 ${align === 'right' ? 'flex-row-reverse' : ''}`}>
        {label}
        {isActive ? (
          currentSortOrder === 'asc' ? (
            <ArrowUp className="w-3 h-3 text-primary" />
          ) : (
            <ArrowDown className="w-3 h-3 text-primary" />
          )
        ) : (
          <ArrowUpDown className="w-3 h-3 opacity-0 group-hover:opacity-40 transition-opacity" />
        )}
      </span>
    </th>
  )
}
